import { Button, Form, Input, Modal, message } from "antd";
import { logoColor } from "../../ui/media";
import React, { useState } from "react";
import axios from "axios";

const { TextArea } = Input;

const DeleteAccount = ({ open, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // ✅ Base URL (optional: replace with your real backend URL)
  const BASE_URL = process.env.REACT_APP_API_URL || "https://yourapi.com";

  const onFinish = async (values) => {
    try {
      setLoading(true);

      // API call
      const response = await axios.delete(`${BASE_URL}/user/auth/delete`, {
        headers: { "Content-Type": "application/json" },
        data:{
            email: values.email?.trim().toLowerCase(),
            password: values.password?.trim(),
            message: values.message?.trim() || ""
        }
      });

      if (response.status === 200) {
        message.success("Your account has been deleted successfully.");
        Modal.success({
          title: "Account Deleted",
          content: "Your account has been successfully deleted.",
        });
        form.resetFields();
        onCancel();
      } else {
        message.error(response.data?.message || "Failed to delete account.");
      }
    } catch (error) {
      console.error("Delete account error:", error);
      message.error(
        error.response?.data?.message ||
          "Something went wrong while deleting your account."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center min-h-screen overflow-hidden">
      {/* 🔵 Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-200 to-cyan-500 animate-gradient bg-[length:400%_400%]" />

      <div className="relative z-10 flex flex-col justify-center items-center gap-10">
        {/* Logo */}
        <div className="flex items-center">
          <img className="w-auto h-20 md:h-32" src={logoColor} alt="Logo" />
        </div>

        {/* Form Card */}
        <div className="rounded-xl shadow-xl backdrop-blur-xl bg-white/10 p-8">
          <h2 className="text-2xl font-bold text-blue-600 text-center mb-6">
            Delete Account
          </h2>

          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            requiredMark={false}
            className="space-y-4 md:w-96"
          >
            {/* Email */}
            <Form.Item
              name="email"
              label={<span className="text-sm text-black">Email</span>}
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input
                placeholder="Email"
                size="large"
                className="rounded-xl text-black"
              />
            </Form.Item>

            {/* Password */}
            <Form.Item
              name="password"
              label={<span className="text-sm text-black">Password</span>}
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password
                placeholder="Password"
                size="large"
                className="rounded-xl text-black"
              />
            </Form.Item>

            {/* Message (Optional) */}
            <Form.Item
              name="message"
              label={<span className="text-sm text-black">Message (Optional)</span>}
            >
              <TextArea
                rows={4}
                placeholder="I want to delete my account because..."
                className="text-black rounded-xl"
              />
            </Form.Item>

            {/* Submit */}
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                block
                size="large"
                loading={loading}
                disabled={loading}
                className="!bg-sky-500 hover:!bg-sky-600 rounded-full mt-2"
              >
                {loading ? "Deleting..." : "Delete"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
